var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "umbrella-selection" }, [
    _c(
      "ul",
      _vm._l(_vm.$parent.models, function (model) {
        return _c(
          "li",
          {
            class: {
              active:
                _vm.$parent.selectedUmbrellaModels &&
                _vm.$parent.selectedUmbrellaModels.includes(model.key),
            },
            attrs: { "data-id": model.key },
            on: { click: _vm.filterUmbrellaModel },
          },
          [_vm._v("\n            " + _vm._s(model.title) + "\n        ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("button", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.$parent.selectedUmbrellaModels.length > 0,
          expression: "$parent.selectedUmbrellaModels.length > 0",
        },
      ],
      domProps: { textContent: _vm._s(this.$parent.t("dealer.reset")) },
      on: { click: _vm.clearUmbrellaSelection },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }